// import Vue from 'vue';
// import Meta from 'vue-meta';

// Vue.use(Meta);

import { createRouter, createWebHistory } from "vue-router";

import PageHome from "@/components/pages/HomePage";
// import PageAbout from "@/components/pages/AboutPage";
import BlogPage from "@/components/pages/BlogPage";
import BlogPostPage from "@/components/pages/BlogPostPage";
import TermsPage from "@/components/pages/TermsPage";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: PageHome,
  },
  // {
  //   path: "/about",
  //   name: "AboutPage",
  //   component: PageAbout,
  // },
  {
    path: "/blog",
    name: "Blog",
    component: BlogPage,
  },
  {
    path: "/blog/:slug",
    name: "BlogPost",
    component: BlogPostPage,
  },
  {
    path: "/terms",
    name: "Terms",
    component: TermsPage,
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
});
